
export const API_URL = process.env.REACT_APP_API_URL
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY
export const SUBJECT_ENABLED = !!parseInt(process.env.REACT_APP_SUBJECT_ENABLED)
export const SECRET_MAX_SUBJECT_LENGTH = process.env.REACT_APP_SECRET_MAX_SUBJECT_LENGTH
export const SECRET_MAX_BODY_LENGTH = process.env.REACT_APP_SECRET_MAX_BODY_LENGTH
